import { Component } from '@angular/core';
import * as d3 from 'd3';

@Component({
  selector: 'app-morningstar-total-and-price-returns',
  templateUrl: './morningstar-total-and-price-returns.component.html',
  styleUrls: ['./morningstar-total-and-price-returns.component.scss'],
  standalone:false
})
export class MorningstarTotalAndPriceReturnsComponent {
  started = false; //is the chart frame started?
  ready=false; //is the data ready and downloaded from data2.ifa.com?
  groupIndex = 0;
  returnType="Total Return"// "Price Return"
  msDate:any = null; //as of date for the data; 
  latestCommonDate:any;

  ngAfterViewInit(){
    this.start();
  }


//2024-07-01 MARK H:
//On the US tab, put, DOW, S&P and Nasdaq up top and add Russell 2000.  Add ASX , TSX Composite, Italy FTSE, and France CAC to Global and drop Commodities. 

tabs:any=[
    {
        name:"U.S.",
        investments:[
            {id:25926, name:'DJIA', type:'Total Return'},
            {id:20666, name:'DJIA', type:'Price Return'},

            {id:26434, name:'S&P 500', type:'Total Return'},
            {id:26433, name:'S&P 500', type:'Price Return'},    
        
            {id:10596, name:'NASDAQ', type:'Total Return'},
            {id:26591, name:'NASDAQ', type:'Price Return'},   
        
            {id:1507, name:'Russell 2000<sup>®</sup>', type:'Total Return'},
            {id:26592, name:'Russell 2000<sup>®</sup>', type:'Price Return'},          
        ]
    },
    {
        name:"Globals",
        investments:[
            {id:26437, name:'ASX 200', type:'Total Return'},
            {id:26436, name:'ASX 200', type:'Price Return'},

            {id:26453, name:'TSX', type:'Total Return'},   
            {id:26452, name:'TSX', type:'Price Return'},

            {id:26439, name:'FTSE 100', type:'Total Return'},
            {id:26438, name:'FTSE 100', type:'Price Return'},   

            {id:26441, name:'CAC 40', type:'Total Return'},
            {id:26440, name:'CAC 40', type:'Price Return'},   
        ]
    }   
]


 start() {
  //console.log("START!")
    if (!this.started) {
      this.started = true;
      this.investmentPerformanceDailyIndexGRR();
    }
}

buttonPress(returnType:string,groupIndex:number){

    //console.log("returnType|groupIndex",returnType,groupIndex)

    d3.selectAll(".btn.active").classed("active",false);

    d3.selectAll(".group").classed("hide",true)
    d3.selectAll(`.group_${groupIndex}`).classed("hide",false)

    if(returnType=="Total Return"){
        d3.select(".btn.total-return").classed("active",true);
        d3.selectAll(".PR").classed("hide",true);
        d3.selectAll(".TR").classed("hide",false);
    }
    else{
        d3.select(".btn.price-return").classed("active",true);
        d3.selectAll(".PR").classed("hide",false);
        d3.selectAll(".TR").classed("hide",true);
    }

    d3.select(`.btn.groupIndex${groupIndex}`).classed("active",true);

}

investmentPerformanceDailyIndexGRR(){

    //console.log("investmentPerformanceDailyIndexGRR")

    var ids = [];
    for(var i=0;i<this.tabs.length;i++){
        ids.push(this.tabs[i].investments.map((x:any)=>x.id))
    }

    var idsString = ids.join(',');
    var endDates="end"
    var startDates="1/1/2024";
    var startingDollar = 1;
    var showIndexValues=true;

    fetch(`https://data2.ifa.com/api/v1/investment/performance/daily/index/grr?ids=${idsString}&startDates=${startDates}&endDates=${endDates}&startingDollar=${startingDollar}&showIndexValues=${showIndexValues}`)
    .then(response => {
        // Check if the request was successful  
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json(); // Parse the response body as JSON  
    })
    .then(resp => {

        //console.log("investmentPerformanceDailyIndexGRR",resp);

        //this.msDate = msDateFormat(resp.results.date);

        let lastDates = resp.results.data
        .filter((x: any) => x.periods !== null && x.periods.length > 0)  // Filter out null or empty periods  
        .map((x:any)=>new Date(x.periods[0].indexDates[x.periods[0].indexDates.length-1]));
        //console.log("lastDates",lastDates)
  
        lastDates.sort((a:Date, b:Date) => {  
          return a.getTime() - b.getTime();  
        });  
  
        this.latestCommonDate = lastDates[0];
        var lcd = new Date(this.latestCommonDate)
      //  msDate=``new Date(Date.UTC(lcd.getUTCFullYear(),lcd.getUTCMonth(),lcd.getUTCDate())).toU();
      this.msDate=`${lcd.getUTCMonth()+1}/${lcd.getUTCDate()}/${lcd.getUTCFullYear()}`
      
        lastDates=null;      
  
        for (let i = 0; i < resp.results.data.length; i++) {
            for (let t = 0; t < this.tabs.length; t++) {
                for (let j = 0; j < this.tabs[t].investments.length; j++) {
                    if (this.tabs[t].investments[j].id == resp.results.data[i].id) {                      
                        if (resp.results.data[i].periods && resp.results.data[i].periods.length > 0) {
                         
                          //this.tabs[t].investments[j].subtitle = resp.results.data[i].periods[0].subtitle;

                            if (resp.results.data[i].periods[0].indexValues && resp.results.data[i].periods[0].indexValues.length > 0) {
                                let _k = resp.results.data[i].periods[0].indexValues[0];

                                this.tabs[t].investments[j]._points = 0;
                                this.tabs[t].investments[j]._percent = 0;
                                for (let k = 0; k < resp.results.data[i].periods[0].indexValues.length; k++) {
                                    if (this.latestCommonDate != null && new Date(resp.results.data[i].periods[0].indexDates[k]) <= this.latestCommonDate && resp.results.data[i].periods[0].indexValues[k] != _k) {

                                      

                                      this.tabs[t].investments[j]._points = (((resp.results.data[i].periods[0].indexValues[k] - _k) > 0 ? "+" : "") + (resp.results.data[i].periods[0].indexValues[k] - _k).toFixed(2)).replace("+","").replace("-","");
                                      this.tabs[t].investments[j]._percent = (((resp.results.data[i].periods[0].indexValues[k] / _k) - 1) * 100).toFixed(2);

                                      this.tabs[t].investments[j].className = (resp.results.data[i].periods[0].indexValues[k] - _k)>=0?"green":"red";
                                      this.tabs[t].investments[j].useID = (resp.results.data[i].periods[0].indexValues[k] - _k)>=0?"#performance-arrow-up--s":"#performance-arrow-down--s";

                                      _k = resp.results.data[i].periods[0].indexValues[k];
                                      this.tabs[t].investments[j].endingValue = _k;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
  
        this.ready=true;
       
    });

   
  }
}



